import { useQuery } from "@tanstack/react-query";
import axiosManager from "../services/axiosManager";

export const useGetNotices = () => {
    const {
        isLoading, data: notices, error,
        refetch, isRefetching,
    } = useQuery({
        queryKey: ["bulletin"],
        queryFn: () => axiosManager.get$("/parent/api/bulletin").then((response) => response?.data),
        retry: 0,
        cacheTime: 0,
        enabled: false,
    });

    return {
        isLoading,
        isRefetching,
        notices,
        error,
        refetch,
    };
};
